import { InvoiceDTO, ItemLineDTO } from '../domain/models';

// Validiert eine Rechnung vor dem API-Call. Liefert ein Array von Fehlermeldungen (leer = OK).
export function validateInvoice(inv: InvoiceDTO): string[] {
  const errors: string[] = [];
  if (!inv) return ['Rechnungsobjekt fehlt'];
  const c = inv.customer || {};

  const hasNumber = !!(c.customerNumber && c.customerNumber.trim());
  const hasName = !!(((c.firstname && c.firstname.trim()) || (c.lastname && c.lastname.trim())));
  const hasStreet = !!(c.street && c.street.trim());
  const hasCity = !!(c.city && c.city.trim());
  const hasPostcode = !!(c.postcode && c.postcode.trim());

  if (!(hasNumber && hasName && hasStreet && hasCity && hasPostcode)) {
    errors.push('Kunde: Nummer, Name (Vor- oder Nachname), Adresse (Straße), Ort und PLZ müssen ausgefüllt sein');
  }

  if (!inv.issueDate || !/^\d{4}-\d{2}-\d{2}$/.test(inv.issueDate)) {
    errors.push('Datum fehlt oder hat falsches Format (YYYY-MM-DD)');
  }
  if (!inv.invoiceNumber || !inv.invoiceNumber.trim()) {
    errors.push('Rechnungsnummer fehlt');
  }
  const items: ItemLineDTO[] = Array.isArray(inv.items) ? inv.items : [];
  if (items.length === 0) {
    errors.push('Mindestens eine Position ist erforderlich');
  }
  items.forEach((it, idx) => {
    const qty = Number(it.quantity);
    if (!Number.isFinite(qty) || qty <= 0) {
      errors.push(`Position ${idx + 1}: Menge muss > 0 sein`);
    }
    const price = Number(it.product?.unitPrice);
    if (!Number.isFinite(price) || price < 0) {
      errors.push(`Position ${idx + 1}: Einzelpreis darf nicht negativ sein`);
    }
    const name = it.product?.name;
    if (!name || !name.trim()) {
      errors.push(`Position ${idx + 1}: Produktname fehlt`);
    }
    const pk = it.product?.productKey;
    if (!pk || !String(pk).trim()) {
      errors.push(`Position ${idx + 1}: Artikelnummer (productKey) fehlt`);
    }
  });
  return errors;
}
